// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: 'b1fbb8a7-a87e-406b-a6db-27c78da52de8',
      type: 'Sprite',
      name: '',
      className: '',
      x: -780,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '5_Season_Pass_Last_Chance_1',
      parent: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f',
      data: {
        DEBUG: true
      }
    },
    {
      id: '3693c34a-0c4c-49f0-86a4-b504649a19c2',
      type: 'Sprite',
      name: '',
      className: '',
      x: 780,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '7_Season_Pass_Last_Chance_3',
      parent: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f',
      data: {
        DEBUG: true
      }
    },
    {
      id: '7f3f8980-ba4d-4757-8434-dec4869aa0d1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 1560,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '6_Season_Pass_Last_Chance_2',
      parent: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f',
      data: {
        DEBUG: true
      }
    },
    {
      id: '2e2f4099-9ace-40e4-b3cd-8429fa6a664b',
      type: 'Container',
      name: 'backgrounds',
      className: '',
      x: 0,
      y: -13,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f'
    },
    {
      id: 'd73aed65-a3a0-4275-96d0-2e2ceac8bb63',
      type: 'Container',
      name: 'title',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f'
    },
    {
      id: '9f84c139-8849-4790-8811-ae00a7383e30',
      type: 'Container',
      name: 'rewardsContainer',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 690,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f',
      data: {
        dynamicValues: {
          y: 'height * 0.54'
        }
      }
    },
    {
      id: '8acaa3ea-5496-4c54-b9eb-007e82bc0cfd',
      type: 'Container',
      name: 'headerContainer',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 340,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f',
      data: {
        dynamicValues: {
          y: 'height * 0.265'
        }
      }
    },
    {
      id: '4030ce5f-c0a5-4561-acf8-02ff22e32e79',
      type: 'Container',
      name: 'buttonsContainer',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 984,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bcbde12b-5468-4d8c-8353-9dfb6dbcab5f',
      data: {
        dynamicValues: {
          y: 'height * 0.768'
        }
      }
    },
    {
      id: '68e0c404-1876-46ee-9284-6a3514eee7c8',
      type: 'Sprite',
      name: '',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: '2e2f4099-9ace-40e4-b3cd-8429fa6a664b',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height + 50'
        }
      }
    },
    {
      id: '11a048cc-f1d1-4a2a-b923-f0774360e23a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Image',
      parent: '2e2f4099-9ace-40e4-b3cd-8429fa6a664b'
    },
    {
      id: 'fc46b976-96ae-43b6-8060-996c92ecdd99',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 193,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 4.190517,
        y: 1.152586
      },
      angle: 0,
      alpha: 0.8,
      visible: true,
      tint: 16706927,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'd73aed65-a3a0-4275-96d0-2e2ceac8bb63'
    },
    {
      id: '774c2ec4-0bb5-49fd-98c8-89e73111a89a',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 185,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'LAST CHANCE!',
      localize: true,
      maxWidth: 658,
      maxHeight: 153,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 80,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x591213',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '0x591213',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd73aed65-a3a0-4275-96d0-2e2ceac8bb63'
    },
    {
      id: '2af2a463-f7c8-421e-a94b-5f61fb2316f4',
      type: 'Container',
      name: 'premiumRewardsContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f84c139-8849-4790-8811-ae00a7383e30',
      stateByName: {
        premium: {
          visible: true,
          alpha: 1
        }
      }
    },
    {
      id: '38bfbc81-203e-48da-97c8-1233b9a04ec2',
      type: 'Container',
      name: 'freeRewardsContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f84c139-8849-4790-8811-ae00a7383e30',
      stateByName: {
        premium: {
          visible: false
        }
      }
    },
    {
      id: '2e9082c1-44b8-4da2-ab75-ed1fbd39c655',
      type: 'Text',
      name: 'descriptionText',
      className: 'colorTags_SPL',
      x: 0,
      y: -215,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You\'ve got $unclaimed rewards!$',
      localize: true,
      maxWidth: 648,
      maxHeight: 84,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 30,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 0,
        dropShadowBlur: 5,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9f84c139-8849-4790-8811-ae00a7383e30',
      data: {
        colorTags: {
          $: '#FDDD3A'
        }
      },
      stateByName: {
        premium: {
          alpha: 1,
          visible: true
        }
      }
    },
    {
      id: 'f50d75e4-da1a-4336-8e5e-9ff7ec802169',
      type: 'Text',
      name: 'buyDescriptionText',
      className: 'colorTags_SPL',
      x: 0,
      y: -215,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$Go Premium$<br>and get these $rewards instantly!$',
      localize: true,
      maxWidth: 648,
      maxHeight: 84,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 500,
        breakWords: false,
        lineHeight: 30,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 0,
        dropShadowBlur: 5,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9f84c139-8849-4790-8811-ae00a7383e30',
      data: {
        colorTags: {
          $: '#FDDD3A'
        }
      },
      stateByName: {
        premium: {
          visible: false
        }
      }
    },
    {
      id: '7f995c47-1270-413c-91ac-8bd7e47e4b45',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'The Season is over!',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 0,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8acaa3ea-5496-4c54-b9eb-007e82bc0cfd'
    },
    {
      id: '80bc3b6f-ded8-4288-9f19-9f86f6b9037f',
      type: 'Container',
      name: 'tierContainer',
      className: 'centerChildren_SPL',
      x: 0,
      y: 23,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8acaa3ea-5496-4c54-b9eb-007e82bc0cfd'
    },
    {
      id: '33c4cb99-e652-4c85-9328-35c751107793',
      type: 'Container',
      name: 'claimButton',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '4030ce5f-c0a5-4561-acf8-02ff22e32e79',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        premium: {
          alpha: 1,
          visible: true
        }
      }
    },
    {
      id: '320dc1cc-2da0-4a96-a976-1956d0f6ad87',
      type: 'Container',
      name: 'buyButton',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '4030ce5f-c0a5-4561-acf8-02ff22e32e79',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        premium: {
          visible: false
        }
      }
    },
    {
      id: 'f50adb0b-48a0-4a09-aeb0-cd2da0bb7e7d',
      type: 'Container',
      name: 'goBackButton',
      className: '',
      x: 0,
      y: 194,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '4030ce5f-c0a5-4561-acf8-02ff22e32e79',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        premium: {
          visible: false
        }
      }
    },
    {
      id: '7a800329-1e4e-4311-93b3-b1032391b4cf',
      type: 'Container',
      name: 'continueWithoutButton',
      className: '',
      x: 0,
      y: 194,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '4030ce5f-c0a5-4561-acf8-02ff22e32e79',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        premium: {
          visible: false
        }
      }
    },
    {
      id: 'd32bdab8-92c7-431f-946f-40abe3aecf2a',
      type: 'Sprite',
      name: 'premiumRewardCircle',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 5.3,
        y: 3.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16578418,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '2af2a463-f7c8-421e-a94b-5f61fb2316f4'
    },
    {
      id: 'cba366c9-1f73-4acf-b91c-105b47302a6f',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.8,
        y: 1.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '2af2a463-f7c8-421e-a94b-5f61fb2316f4'
    },
    {
      id: '412e2de5-2e54-4f86-83db-2630390b4144',
      type: 'Container',
      name: 'premiumRewardsSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2af2a463-f7c8-421e-a94b-5f61fb2316f4'
    },
    {
      id: 'f98202c4-b6f9-4c87-974a-d0976207613e',
      type: 'Sprite',
      name: 'freeRewardCircle',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 5.3,
        y: 3.9
      },
      angle: 0,
      alpha: 0.8,
      visible: true,
      tint: 5816831,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '38bfbc81-203e-48da-97c8-1233b9a04ec2'
    },
    {
      id: '14efd2e9-73c2-4ce2-856b-8aec690dfa19',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.8,
        y: 1.8
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '38bfbc81-203e-48da-97c8-1233b9a04ec2'
    },
    {
      id: 'ce078380-39b7-4587-91e1-af62050fc30f',
      type: 'Container',
      name: 'freeRewardsSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '38bfbc81-203e-48da-97c8-1233b9a04ec2'
    },
    {
      id: '2c3ec764-c06c-4ad9-ad9a-771bfb47f9f3',
      type: 'Text',
      name: '',
      className: '',
      x: -40,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You reached Tier',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 0,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '80bc3b6f-ded8-4288-9f19-9f86f6b9037f'
    },
    {
      id: '5d9389b6-dc67-4eb5-9fd6-ad2774b65f99',
      type: 'Container',
      name: '',
      className: '',
      x: 138,
      y: 4,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '80bc3b6f-ded8-4288-9f19-9f86f6b9037f'
    },
    {
      id: '9deee574-cd30-4854-9df4-f917ffaab64e',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      skin: '',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1.04,
        y: 1.15
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '33c4cb99-e652-4c85-9328-35c751107793',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '05ff669b-6a00-477e-a1fb-805678140657',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Claim',
      localize: true,
      maxWidth: 419,
      maxHeight: 117,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#19580F',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#19580F',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '33c4cb99-e652-4c85-9328-35c751107793'
    },
    {
      id: '745a66eb-d126-4794-9b62-f70afcafe1a2',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      skin: '',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1.04,
        y: 1.15
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '320dc1cc-2da0-4a96-a976-1956d0f6ad87',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'b7f91137-b220-434f-888f-bfe283958235',
      type: 'Text',
      name: 'buyButtonLabel',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Go Premium <amount>',
      localize: true,
      maxWidth: 419,
      maxHeight: 117,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#19580F',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#19580F',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '320dc1cc-2da0-4a96-a976-1956d0f6ad87'
    },
    {
      id: 'b0af4f1c-6b70-47a3-83d8-a33044c15a94',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      skin: '',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'f50adb0b-48a0-4a09-aeb0-cd2da0bb7e7d',
      data: {
        color: 'orange',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'cde872eb-6d48-443b-b99a-133080a4c1b7',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Go back to Premium Pass',
      localize: true,
      maxWidth: 289,
      maxHeight: 89,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 38,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#BB3318',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 300,
        breakWords: false,
        lineHeight: 32,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#BB3318',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f50adb0b-48a0-4a09-aeb0-cd2da0bb7e7d'
    },
    {
      id: '28b4fd1e-2fb9-4741-945c-6363728c8abd',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      skin: '',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '7a800329-1e4e-4311-93b3-b1032391b4cf',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'dedf6ce3-1ed8-4bc8-993b-0549fba9ee7b',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Continue without Premium Pass',
      localize: true,
      maxWidth: 289,
      maxHeight: 89,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 38,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0424CA',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 300,
        breakWords: false,
        lineHeight: 32,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#0424CA',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7a800329-1e4e-4311-93b3-b1032391b4cf'
    },
    {
      id: '810a3002-5ad3-4d6c-a834-7583ce447116',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Green_Node',
      parent: '5d9389b6-dc67-4eb5-9fd6-ad2774b65f99'
    },
    {
      id: 'f4e28234-0856-4448-9df4-7373a507b593',
      type: 'Text',
      name: 'tierText',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '21',
      localize: false,
      maxWidth: 43,
      maxHeight: 55,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#1C6316',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '5d9389b6-dc67-4eb5-9fd6-ad2774b65f99'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'premium'
  ],
  handleResize: false
} as const;

export class SeasonPassLastChanceLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  backgrounds!: Container;
  title!: Container;
  rewardsContainer!: Container & { data: typeof raw['list'][6]['data'] };
  headerContainer!: Container & { data: typeof raw['list'][7]['data'] };
  buttonsContainer!: Container & { data: typeof raw['list'][8]['data'] };
  premiumRewardsContainer!: Container;
  freeRewardsContainer!: Container;
  descriptionText!: Text & { data: typeof raw['list'][15]['data'] };
  buyDescriptionText!: Text & { data: typeof raw['list'][16]['data'] };
  tierContainer!: Container;
  claimButton!: Container & { data: typeof raw['list'][19]['data'] };
  buyButton!: Container & { data: typeof raw['list'][20]['data'] };
  goBackButton!: Container & { data: typeof raw['list'][21]['data'] };
  continueWithoutButton!: Container & { data: typeof raw['list'][22]['data'] };
  premiumRewardCircle!: Sprite;
  premiumRewardsSlot!: Container;
  freeRewardCircle!: Sprite;
  freeRewardsSlot!: Container;
  buyButtonLabel!: Text;
  tierText!: Text;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Container & { data: typeof raw['list'][6]['data'] } | Container & { data: typeof raw['list'][7]['data'] } | Container & { data: typeof raw['list'][8]['data'] } | Sprite & { data: typeof raw['list'][9]['data'] })[];
  colorTags_SPL!: (Text & { data: typeof raw['list'][15]['data'] } | Text & { data: typeof raw['list'][16]['data'] })[];
  centerChildren_SPL!: (Container)[];
  rotate_SPL!: (Sprite)[];
  StateName!: 'premium';

  constructor() {
    populate(this, raw);
  }
}
